import { useCallback, useLayoutEffect, useRef } from 'react';

export type Mounted = () => boolean;

function useMounted(): Mounted {
  const mountedRef = useRef(true);

  useLayoutEffect(
    () => () => {
      mountedRef.current = false;
    },
    [],
  );

  return useCallback(() => mountedRef.current, []);
}

export default useMounted;
